module.exports = __webpack_public_path__ + "static/media/reset.371e6182.svg";